import React from 'react';
import { PieChart, Pie, Cell } from 'recharts';

const CustomGauge = ({ value }) => {
  const gaugeValue = Math.min(100, Math.max(0, value)); // Keep value between 0-100

  // Define color zones
  const colors = ['#ff4500', '#f0ad4e', '#007bff']; // Red, Yellow, Blue
  const getColor = () => (gaugeValue < 30 ? colors[0] : gaugeValue < 60 ? colors[1] : colors[2]);

  // Define gauge chart data
  const data = [
    { value: gaugeValue },
    { value: 100 - gaugeValue }, // Empty part of the gauge
  ];

  return (
    <div style={{ textAlign: 'center' , backgroundColor: '#ffffff'}}>
      <h3 style={{ color: '#727273' }}>General sentiment towards Israel:</h3>
      <h2 style={{ color: getColor() }}>
        {gaugeValue < 30 ? 'Negative' : gaugeValue < 60 ? 'Neutral' : 'Positive'}
      </h2>
      <h4 style={{ color: '#727273' }}>
        <span style={{ color: getColor(), fontWeight: 'bold' }}>{value}%</span> of posts about Israel are positive
      </h4>
      <PieChart width={600} height={400}>
        <Pie
          data={data}
          startAngle={180}
          endAngle={0}
          innerRadius={100}
          outerRadius={180}
          dataKey="value"
        >
          <Cell key="filled" fill={getColor()} />
          <Cell key="empty" fill="#e0e0e0" />
        </Pie>
      </PieChart>
    </div>
  );
};

export default CustomGauge;
